import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import CompanyAndRoleTable from './CompanyAndRoleTable';
import { useNavigate } from 'react-router-dom';
import {
  editManufacturerRoleToExistingFirmAction,
  getCompanyAndRoleAction,
  getpricingGeographyAction,
} from '../../Onboarding/auth/action';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';

const DealerShipDetail = ({ data, firmData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(data[0]?.secondary_industry_id);
  const [companyRoleData, setCompanyRoleData] = useState(
    data[0]?.company_roles,
  );
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedPricingGeoraphyValue, setSelectedPricingGeographyValue] =
    useState(null);

  const [newRoleData, setNewRoleData] = useState([]);
  const [newPricingGeographyData, setNewPricingGeographyData] = useState([]);

  const [open, setOpen] = useState(false);
  const [openPricingGeographyModal, setOpenPricingGeographyModal] =
    useState(false);

  // const handleOnRefresh = () => {
  //   setTabValue(data[0]?.secondary_industry_id);
  //   setCompanyRoleData(data[0]?.company_roles);
  // };
  const handleTabChange = (event, newValue) => {
    const company = data.find(
      (company) => company.secondary_industry_id === newValue,
    );
    const company_roles = company.company_roles;
    setCompanyRoleData(company_roles);
    setTabValue(newValue);
  };
  const getRoles = async (manufacturer_id, current_region_role_id) => {
    const payload = {
      manufacturer_id: manufacturer_id,
    };

    const { data, error, message } = await getCompanyAndRoleAction(payload);

    if (!error) {
      const temp = data[0];

      const roleData = temp?.roles.filter((item) => {
        return item.region_role_id !== current_region_role_id;
      });
      return roleData;
    } else {
      return toast.error(message);
    }
  };
  const getGeographyPricing = async (company_id, district_id) => {
    const params = new URLSearchParams();
    params.append('district_id', district_id);
    params.append('manufacturer_id', company_id);

    const { data, error, message } = await getpricingGeographyAction(params);

    if (!error) {
      return data;
    } else return toast.error(message);
  };

  const handleEditClick = async (clickedRow) => {
    const roleData = await getRoles(
      clickedRow.active_dealership_firm_details.manufacturer_id,
      clickedRow.active_dealership_firm_details.region_role_id,
    );
    const obj = clickedRow.active_dealership_firm_details;
    obj.roleData = roleData;
    setNewRoleData(obj);
    handleModalOpen();
  };
  const handlePricingGeographyEditClick = async (clickedRow) => {
    const pricingGeographyData = await getGeographyPricing(
      clickedRow.active_dealership_firm_details.manufacturer_id,
      clickedRow.active_dealership_firm_details.district_id,
    );
    const obj = clickedRow.active_dealership_firm_details;
    obj.pricingGeographyData = pricingGeographyData;
    setNewPricingGeographyData(obj);
    handlePricingGeographyModalOpen();
  };

  const handleChangeRoleClick = async () => {
    const firm_role_id = newRoleData?.roleData?.find((item) => {
      return item.region_role_id === selectedValue;
    }).firm_role_id;

    await UpdateRole(
      newRoleData.manufacturer_role_map_id,
      1,
      selectedValue,
      firm_role_id,
    );
  };
  const handleChangePricingGeographyClick = async () => {
    await UpdatePricingGeographyId(
      selectedPricingGeoraphyValue,
      newPricingGeographyData.manufacturer_pricing_geography_id ? 1 : 2,
      newPricingGeographyData.manufacturer_role_map_id,
    );
  };
  const [deleteData, setDeleteData] = useState([]);
  const handleRemoveClick = async (row) => {
    setDeleteModal(true);
    setDeleteData(row);
  };

  const deleteManufacturer = async (row) => {
    await UpdateRole(
      row.active_dealership_firm_details.manufacturer_role_map_id,
      3,
      row.active_dealership_firm_details.region_role_id,
      row.active_dealership_firm_details.firm_role_id,
    );
  };

  const UpdateRole = async (
    manufacturer_role_map_id,
    operation_type,
    region_role_map_id,
    firm_role_id,
  ) => {
    const payload = {
      manufacturer_role_map_id: manufacturer_role_map_id,
      operation_type: operation_type,
      region_role_map_id: region_role_map_id,
      firm_role_id: firm_role_id,
    };

    const { error, message } = await editManufacturerRoleToExistingFirmAction(
      payload,
    );

    if (!error) {
      handleModalClose();
      navigate(0);
      return toast.success(message);
    } else {
      return toast.error(message);
    }
  };
  const UpdatePricingGeographyId = async (
    pricing_geography_id,
    operation_type,
    manufacturer_role_map_id,
  ) => {
    const payload = {
      manufacturer_pricing_geography_id: pricing_geography_id,
      operation_type: operation_type,
      manufacturer_role_map_id: manufacturer_role_map_id,
    };

    const { error, message } = await editManufacturerRoleToExistingFirmAction(
      payload,
    );

    if (!error) {
      handlePricingGeographyModalClose();
      navigate(0);
      return toast.success(message);
    } else {
      return toast.error(message);
    }
  };
  const onAddIndustry = (firm) => {
    dispatch({
      type: 'RESET_FIRM_ONBOARDING_REDUCER',
    });

    dispatch({
      type: 'SET_ADDING_DEALERSHIP_FROM_PROFILE',
      data: {
        ...firm,
        district_id: firm.geographic_info.district_info.district_id,
      },
    });

    navigate('/IndustrySelect');
  };

  const handleModalOpen = () => setOpen(true);
  const handleModalClose = () => {
    setOpen(false);
    setNewRoleData([]);
  };
  const handlePricingGeographyModalOpen = () =>
    setOpenPricingGeographyModal(true);
  const handlePricingGeographyModalClose = () => {
    setOpenPricingGeographyModal(false);
    setNewPricingGeographyData([]);
  };
  const [deleteModal, setDeleteModal] = useState(false);

  const deleteManufacturerModal = (
    <Modal
      open={deleteModal}
      onClose={() => setDeleteModal(false)}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 250,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            textAlign: 'center',
          }}
        >
          Are you sure you want to Delete{' '}
          {deleteData?.active_dealership_firm_details?.manufacturer_name}?
        </Typography>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '3rem' }}
        >
          <Button
            variant='outlined'
            color='success'
            onClick={() => setDeleteModal(false)}
          >
            No
          </Button>
          <Button
            variant='outlined'
            color='error'
            onClick={() => deleteManufacturer(deleteData)}
          >
            Delete
          </Button>
        </Stack>
      </Box>
    </Modal>
  );

  const roleChangeModal = (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 300,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          Select role you want to change
        </Typography>
        <FormControl
          fullWidth
          sx={{ mt: '2rem' }}
        >
          <InputLabel id='dropdown-label'>Select Role</InputLabel>
          <Select
            label='Select Role'
            value={selectedValue}
            onChange={(e) => setSelectedValue(e.target.value)}
          >
            {newRoleData?.roleData?.map((item) => (
              <MenuItem
                key={item.region_role_id}
                value={item.region_role_id}
              >
                {item.display_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '2rem' }}
        >
          <Button
            variant='outlined'
            color='error'
            onClick={() => handleModalClose()}
          >
            Cancel
          </Button>
          <Button
            variant='outlined'
            color='primary'
            onClick={handleChangeRoleClick}
          >
            Confirm
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
  const pricingGeographyModal = (
    <Modal
      open={openPricingGeographyModal}
      onClose={handlePricingGeographyModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 300,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          Select Pricing Geography you want to change
        </Typography>
        <FormControl
          fullWidth
          sx={{ mt: '2rem' }}
        >
          <InputLabel id='dropdown-label'>Select Pricing Geography</InputLabel>
          <Select
            label='Select Role'
            value={selectedPricingGeoraphyValue}
            onChange={(e) => setSelectedPricingGeographyValue(e.target.value)}
          >
            {newPricingGeographyData?.pricingGeographyData?.map((item) => (
              <MenuItem
                key={item.pricing_geography_id}
                value={item.pricing_geography_id}
              >
                {item.pricing_geography_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '2rem' }}
        >
          <Button
            variant='outlined'
            color='error'
            onClick={() => handlePricingGeographyModalClose()}
          >
            Cancel
          </Button>
          <Button
            variant='outlined'
            color='primary'
            onClick={handleChangePricingGeographyClick}
          >
            Confirm
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
  return (
    <Card sx={{ mt: '1rem' }}>
      {deleteManufacturerModal}
      {roleChangeModal}
      {pricingGeographyModal}
      <CardHeader
        title='Dealership Detail'
        sx={{ backgroundColor: '#f5f5f5' }}
        action={
          <Button
            variant='outlined'
            onClick={() => onAddIndustry(firmData)}
          >
            Add Industry
          </Button>
        }
      />

      <CardContent>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label='Sub Industry Tab'
          >
            {data.length > 0 &&
              data?.map((company, index) => (
                <Tab
                  value={company?.secondary_industry_id}
                  label={company?.secondary_industry_name}
                  wrapped
                />
              ))}
          </Tabs>
        </Box>
        <Box sx={{ mt: '1rem' }} />
        <CompanyAndRoleTable
          rows={companyRoleData}
          handleEditClick={handleEditClick}
          HandleRemoveClick={handleRemoveClick}
          handlePricingGeographyEditClick={handlePricingGeographyEditClick}
        />
      </CardContent>
    </Card>
  );
};

export default DealerShipDetail;
